
import {computed, defineComponent} from "vue";
import {Constants} from "../../../consts/constants";

export default defineComponent({
  props: {
    title: {
      type: String,
      default: 'Welcome to Infigo'
    },
    subtitle: {
      type: String,
      default: 'Explore our Editor Iframe'
    }
  },
  setup() {
    return {
      logoUrl: Constants.InfigoURL,
    }
  }
});
